import { render } from "./MigracionActivosDos.vue?vue&type=template&id=7e0f4425"
import script from "./MigracionActivosDos.vue?vue&type=script&lang=js"
export * from "./MigracionActivosDos.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__